import "../../../styles/Technologies.css";
import Card from "./Card";
import { useState, useEffect } from "react";
import technologies from "../../../tech.json";
import { v4 as uuidv4 } from "uuid";

const Technologies = () => {
  const [cards, setCards] = useState();

  useEffect(() => {
    setCards(technologies);
  }, [cards]);

  return (
    <section className="tech" id="technologies">
      <div className="tech__intro">
        <h2>Technical Skills</h2>
        <div className="underline">
          <div className="heading-underline"></div>
          <div className="heading-underline-end"></div>
        </div>
      </div>
      <div className="tech__card-container">
        {cards &&
          cards.technologies.map((item) => {
            const uniqueKey = uuidv4();

            return (
              <Card
                key={uniqueKey}
                name={item.name}
                icon={item.icon}
                id={item.id}
                description={item.description}
                color={item.color}
              />
            );
          })}
      </div>
    </section>
  );
};

export default Technologies;
